import { useNavigate, useParams } from "react-router-dom"
import { AlertContext } from "contexts/AlertContext"
import { POST } from "api/request"
import { useContext } from "react"
import * as url from 'api/urls'
import Modal from "./Modal"

interface ActionResponse {
  result: boolean
  error: string
}

interface ProfileSettingsModalProps {
  body: board.BoardResponse | undefined | null
  onClose: () => void
  setModal: (s: string) => void
  onReload: () => void
}

const ProfileSettingsModal: React.FC<ProfileSettingsModalProps> = ({ body, onClose, setModal, onReload }) => {
  const data = body?.data
  const params = useParams()

  const navigate = useNavigate()
  const { showAlert } = useContext(AlertContext)

  const handleAutoAccept = async (action: string) => {
    try {
      const response = await POST(url.updatedBoard(params['*']), {
        body: {
          auto_accept_book: action === 'on' ? 1 : 0
        }
      })
      if (response.ok) {
          showAlert(action === 'on' ? 'Włączono' : 'Wyłączono', 'success')
          window.history.back()
          onClose()
          onReload()
      } else {
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleSubmit = async (action: string) => {
    try {
      const response = await POST(url.action(params['*']), {
        body: {
          action: action
        }
      })
      if (response.ok) {
        const responseData: ActionResponse = response.data;
        if (!responseData.result) {
          window.history.back()
          onClose()
          showAlert(responseData.error, 'error')
        } else {
          showAlert(action, 'success')
          window.history.back()
          onClose()
          onReload()
        }
      } else {
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Modal
      icon="settings"
      onClose={onClose}
      title={`Ustawienia profilu`}
      primaryButton="Zamknij"
      primaryButtonAction={onClose}
      secondaryButton="Usuń profil"
      secondaryButtonAction={() => setModal('delete')}
      noTopPadding>
      <div className="modal__profileSettings" style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
        <div className="payment">
          {/* {data?.is_paid
            ? <span onClick={() => handleSubmit('setUnpaid')}>Opłacone</span>
            : <span className="error" onClick={() => handleSubmit('setPaid')}>Opłać teraz</span>} */}
        </div>
        <div
          className="item toggle"
          onClick={() => {
            handleSubmit(`${data?.is_published ? 'unpublish' : "publish"}`)
          }}>
          {data?.is_published ? "Widoczny w internecie" : "Niewidoczny w internecie"}
          <div className={`box ${data?.is_published && 'active'}`}><div className="circle"></div></div>
        </div>
        <div
          className="item toggle"
          onClick={() => {
            handleAutoAccept(`${data?.auto_accept_book ? 'off' : "on"}`)
          }}>
          Automatyczne akceptowanie wpisów
          <div className={`box ${data?.auto_accept_book && 'active'}`}><div className="circle"></div></div>
        </div>
        <div
          className="item"
          onClick={() => {
            navigate(`/addprofile/${body?.data.qr_id}/add`)
          }}>
          + Dodaj kolejny profil do tego kodu QR
        </div>
        <div
          className="item"
          onClick={() => {
            setModal('password')
          }}>
          Zabezpiecz profil hasłem
        </div>
      </div>
    </Modal>)
}

export default ProfileSettingsModal